import LogUtils from "./log-utils.ts";

export default class ParseUtils {
  public static parseNumber(payload: Record<string, unknown>, fieldName: string): number {
    const field: unknown = this.enforceFieldExists(payload, fieldName);

    // enforce field is a number
    if (typeof field !== "number") {
      LogUtils.error(`parse error: '${fieldName}' field was type '${typeof field}' when it should be 'number'`);
    }

    // success
    return field;
  }

  /**
   * TODO
   */
  public static parseString(
    payload: Record<string, unknown>,
    fieldName: string,
    expectedValue: string | null = null,
  ): string {
    const field: unknown = this.enforceFieldExists(payload, fieldName);

    // enforce field is string
    if (typeof field !== "string") {
      LogUtils.error(`parse error: '${fieldName}' field was type '${typeof field}' when it should be 'string'`);
    }

    // enforce that the string was a certain value
    if (expectedValue !== null) {
      if (field !== expectedValue) {
        LogUtils.error(
          `parse error; '${fieldName}' field had value '${field}' when it should have been '${expectedValue}'`,
        );
      }
    }

    // success
    return field;
  }

  /**
   * TODO
   */
  public static parseStringArray(payload: Record<string, unknown>, fieldName: string): string[] {
    const field: unknown[] = this.parseArray(payload, fieldName);

    // enforce field entries are strings
    field.forEach((entry: unknown): void => {
      if (typeof entry !== "string") {
        LogUtils.error(
          `parse error: '${fieldName}' field contained an entry of type '${typeof entry}' when it should be 'string'`,
        );
      }
    });

    // success
    return field as string[];
  }

  /**
   * TODO
   */
  public static parseObject(payload: Record<string, unknown>, fieldName: string): Record<string, unknown> {
    const field: unknown = this.enforceFieldExists(payload, fieldName);

    // enforce field is object
    if (typeof field !== "object") {
      LogUtils.error(`parse error: '${fieldName}' field was type '${typeof field}' when it should be 'object'`);
    }

    return field as Record<string, unknown>;
  }

  /**
   * TODO
   */
  public static parseArray(payload: Record<string, unknown>, fieldName: string): unknown[] {
    const field: unknown = this.enforceFieldExists(payload, fieldName);

    // enforce field is array
    if (!Array.isArray(field)) {
      LogUtils.error(`parse error: '${fieldName}' field was type '${typeof field}' when it should be 'array'`);
    }

    return field;
  }

  /**
   * TODO
   */
  private static enforceFieldExists(payload: Record<string, unknown>, fieldName: string): unknown {
    // enforce that the requested field exists
    if (payload[fieldName] === undefined) {
      LogUtils.error(`parse error: missing '${fieldName}' field`);
    }

    // success
    return payload[fieldName];
  }
}
